import { useEffect } from 'react';

/**
 * 브라우저 이탈(새로고침/뒤로가기/탭 닫기) 시 미저장 답안 유실을 경고한다.
 * `shouldWarn()`이 true일 때만 브라우저 기본 "페이지를 벗어나시겠습니까?" 프롬프트를 띄운다.
 * 앱이 의도적으로 reload 하는 경우(임시저장/제출 성공 후)는 shouldWarn()이 false를 반환하도록 하여 경고를 억제한다.
 * BUG-003: 임시저장은 현재 문제만 서버 저장하므로, 저장하지 않은 다른 문제 답안이 이탈로 사라지는 것을 방지.
 */
export function useBeforeUnloadGuard(shouldWarn: () => boolean) {
  useEffect(() => {
    const handler = (event: BeforeUnloadEvent) => {
      if (!shouldWarn()) return;
      event.preventDefault();
      // 일부 브라우저는 returnValue 설정을 요구한다.
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [shouldWarn]);
}
